<template>
<div>
    <div @click="openMessage=true" style="cursor:pointer">
        <v-img :src="require('@/assets/cart/banner.jpg')" height="200">
            <div class="d-flex justify-center mt-12">
                <div><v-img :src="require('@/assets/cart/text.png')" width="400"></v-img></div>
            </div>
            <div class="d-flex justify-end mr-8 mt-n6">
                <div><v-img :src="require('@/assets/cart/sello.png')" width="100"></v-img></div>
            </div>
        </v-img>
    </div>

    <v-card outlined max-width="950px" class="mx-auto pa-6 pa-sm-10 mb-4" style="border-top-left-radius:0; border-top-right-radius:0;" v-if="openMessage">
        <div class="text-center">
            <v-btn text class="accent--text" @click="openMessage=false">
                <v-icon small color="accent" class="mr-2">fa-times</v-icon>
                Close
            </v-btn>
        </div>
        <div class="headline font-weight-medium primary--text">
            100% GUARANTEEE
        </div>
        <div class="font-weight-medium">
            Satisfaction or money back
        </div>

        <div class="mt-2">
            Your teen deserves to have a vibrant and fulfilling future. At 3 Steps to College, we promise to help your teen go through essential lessons and information. All we ask is your teen´s promise to open his/her mind and to listen and work with us. We will achieve results if we all work together. If your teen commits to doing that, YOU WILL SEE RESULTS. But it is not only about just listening to this program, but your teen must also work on our 3S ONLINE WORLD it at his/her own time. Our Online World contains powerful tools, and it is a platform your teen will be able to use for life. 
            The program requires TIME and EFFORT, but <span class="font-weight-medium">if you don’t feel like it is working for you, you can contact us and ask for a return at no cost to you within 14 days of purchase.</span> Simply contact our Customer Service team at <a class="accent--text" href="mailto:info@3stepstocollege.com">info@3stepstocollege.com</a> within 14 days of your purchase and request a refund. The only risk is inaction!
        </div>
    </v-card>
</div>
</template>

<script>
export default {
    data: () => ({
        openMessage: false
    })
}
</script>
